
/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, getProp, ExtendContainerProps, patchEvents, $Container} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';

export type $RubyInteractiveState = 'focused' | 'pressed' | 'normal' | 'disabled';

export type $RubyInteractiveProps = ExtendContainerProps<{
    onOver?: () => void;
    onOut?: () => void;
    onDown?: () => void;
    onUp?: () => void;
    onTap?: () => void;
    onEnable?: () => void;
    onDisable?: () => void;
    disabled?: boolean;
}>;

export const $RubyInteractive: FC<$RubyInteractiveProps> = (props) => {
    const enabled = Store.computed(() => !getProp(props.disabled));
    const {onEnable, onDisable} = props;

    const offDisable = Store.effect(() => {
        getProp(enabled) ? getProp(onEnable)?.() : getProp(onDisable)?.();
    });

    props.events ??= {};

    patchEvents(props.events, {
        pointerover: getProp(props.onOver),
        pointerout: getProp(props.onOut),
        pointerdown: getProp(props.onDown),
        pointerup: getProp(props.onUp),
        pointerupoutside: getProp(props.onUp),
        pointertap: getProp(props.onTap),
        destroyed: [offDisable]
    });

    return <$Container
        {...props}
        interactive={enabled}
        buttonMode={enabled}
    />;
};
